// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"78":"8c5b1acc","297":"24305b4a","629":"efd1507f","821":"8871102d","872":"72456c72"}[chunkId] + ".js";
};